"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("@uifabric/styling/lib/index");
index_1.registerIconAlias('trash', 'delete');
index_1.registerIconAlias('onedrive', 'onedrivelogo');
//# sourceMappingURL=iconAliases.js.map